import ResponseEntity, { DtoConversionError, RequestEntity } from "../index";

export default class OutputPerson extends ResponseEntity {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly position: string,
    public readonly email: string,
    public readonly profile: string,
    public readonly description?: string,
    public readonly position_short?: string
  ) {
    super(id);
  }

  static convert(input: any): OutputPerson {
    if (input instanceof OutputPerson) return input;

    const id = input.id ?? undefined;
    const name = input.name ?? undefined;
    const position = input.position ?? undefined;
    const email = input.email ?? undefined;
    const profile = input.profile ?? undefined;
    const description = input.description ?? undefined;
    const position_short = input.position_short ?? undefined;

    if (typeof id !== "string")
      throw new OutputPersonConversionError("id", input);
    if (typeof name !== "string")
      throw new OutputPersonConversionError("name", input);
    if (typeof position !== "string")
      throw new OutputPersonConversionError("position", input);
    if (typeof email !== "string")
      throw new OutputPersonConversionError("email", input);
    if (typeof profile !== "string")
      throw new OutputPersonConversionError("profileLocation", input);
    if (typeof description !== "string" && description !== undefined)
      throw new OutputPersonConversionError("description", input);
    if (typeof position_short !== "string" && position_short !== undefined)
      throw new OutputPersonConversionError("position_short", input);

    return OutputPersonConversionError.propagate(
      OutputPersonConversionError.dtoName,
      () =>
        new OutputPerson(
          id,
          name,
          position,
          email,
          profile,
          description,
          position_short
        )
    );
  }
}

class OutputPersonConversionError extends DtoConversionError {
  public static dtoName: string = "OutputPerson";
  constructor(propertyName: string, rawData: any, hint?: string) {
    super(OutputPersonConversionError.dtoName, propertyName, rawData, hint);
  }
}

export class RequestPersonsByGroup extends RequestEntity {
  constructor(public readonly group: string) {
    super();
  }
}
